<div class="row"  *ngIf="page_count">
	<div class="col">
		<br>
		<nav aria-label="Page navigation example">
			<ul class="d-flex flex-wrap pagination justify-content-center">
				<li class="page-item" *ngIf="page_arr.length>1"> 
					<a class="page-link" href="javascript:void(0)"
					(click)="pre_click_page()" 
						aria-label="Previous"> <span aria-hidden="true">«</span> <span class="sr-only">前一頁</span> 
					</a> 
				</li>
				<li class="page-item" [ngClass]="data.page == page ? 'active' : ''" 
					*ngFor="let page of page_arr; let i = index" (click)="click_page(page)">
					<a href="javascript:void(0)" class="page-link">
						{{page*1+1}}
					</a>
				</li>
				<li class="page-item" *ngIf="page_arr.length>1">
					<a class="page-link" href="javascript:void(0)" (click)="aft_click_page()" aria-label="Next"> 
						<span aria-hidden="true">»</span> 
						<span class="sr-only">下一頁</span> 
					</a>
				</li>
				<div class="pl-3 flex-nowrap d-flex mt-1">
					<input type="number" style="max-width: 200px;" [(ngModel)]="input_tmp_page" class="form-control" [ngStyle]="getstyle()" (change)="inputpage()">
					<span style="font-size:22px;margin-left:4px;">&nbsp;/&nbsp;{{page_count}}</span>
				</div>
			</ul>
		</nav>
		<hr>
		<br>
	</div>
</div>
